var map = {
	"./Queen-en.json": 1026,
	"./Queen-es.json": 1027,
	"./Storfund-de.json": 1028,
	"./Storfund-en.json": 1029,
	"./Storfund-es.json": 1030,
	"./Storfund-fr.json": 1031,
	"./Storfund-it.json": 1032,
	"./Storfund-pt.json": 1033,
	"./ThomsonReutersCredentialing-de.json": 1034,
	"./ThomsonReutersCredentialing-en.json": 1035,
	"./ThomsonReutersCredentialing-es.json": 1036,
	"./ThomsonReutersCredentialing-fr.json": 1037,
	"./ThomsonReutersCredentialing-it.json": 1038,
	"./ThomsonReutersCredentialing-pt.json": 1039,
	"./stevetesting-de.json": 1040,
	"./stevetesting-en.json": 1041,
	"./stevetesting-es.json": 1042,
	"./stevetesting-fr.json": 1043,
	"./stevetesting-it.json": 1044,
	"./stevetesting-pt.json": 1045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 243;